// The pill track is inline-sized in the design (Figma 232:355124, 261×37) rather than stretched,
// and there are no tab panes to reserve space for. Categories are per-account, so the strip can
// be wider than the design's four tabs — it scrolls instead of wrapping.

.tabs {
  :global(.ant-tabs-nav) {
    margin: 0;
  }

  :global(.ant-tabs-nav-wrap) {
    display: inline-flex;
    flex: none;
  }

  :global(.ant-tabs-content-holder) {
    display: none;
  }
}
